export default __webpack_public_path__ + "static/media/laboratory.8bfd7318.jpg";